import { render } from "./UbahLokasiView.vue?vue&type=template&id=2753325c"
import script from "./UbahLokasiView.vue?vue&type=script&lang=js"
export * from "./UbahLokasiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__